const createSlot = (name) => {
  const slot = document.createElement("slot");
  slot.setAttribute("name", name);
  return slot;
};
export {
  createSlot
};
//# sourceMappingURL=createSlot.js.map
